import { render, staticRenderFns } from "./Projekt.vue?vue&type=template&id=058c9882&"
import script from "./Projekt.vue?vue&type=script&lang=js&"
export * from "./Projekt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports